module.exports = __webpack_public_path__ + "img/loading-animation.c9bc7695.gif";